"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailIsRequired = void 0;
exports.validateEmail = validateEmail;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _angieslistAppPlatform = require("angieslist-app-platform");
// Validation rules: https://angieslist.atlassian.net/wiki/display/SE/Data+Validation

var emailIsRequired = exports.emailIsRequired = {
  email: {
    required: true,
    pattern: 'email'
  }
};
function validateEmail(email) {
  return !(0, _isEmpty2["default"])(email) && _angieslistAppPlatform.validation.validate({
    email: email
  }, emailIsRequired).isValid;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/validations/updateContactPreferences.js
// module id = 2107
// module chunks = 9